/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Meet_Eu_Ai_ActInputs */



/**
* | output |
* | --- |
* | "How does oneAI help with the EU AI Act?" |
*
* @param {Uno_Welcome_Suggestion_Meet_Eu_Ai_ActInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_meet_eu_ai_act = /** @type {((inputs?: Uno_Welcome_Suggestion_Meet_Eu_Ai_ActInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Meet_Eu_Ai_ActInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie hilft oneAI beim EU AI Act?")
	return /** @type {LocalizedString} */ ("How does oneAI help with the EU AI Act?")
});